var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Prop, Component, Emit, Watch } from 'vue-property-decorator';
var PromptDialog = /** @class */ (function (_super) {
    __extends(PromptDialog, _super);
    function PromptDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        return _this;
    }
    PromptDialog.prototype.cancelled = function () { };
    PromptDialog.prototype.accepted = function () {
        this.loading = true;
    };
    PromptDialog.prototype.onValueChanged = function (val, oldVal) {
        if (oldVal !== val && val) {
            // reset the loading indicator
            this.loading = false;
        }
    };
    __decorate([
        Prop({ type: Boolean, required: true }),
        __metadata("design:type", Boolean)
    ], PromptDialog.prototype, "value", void 0);
    __decorate([
        Prop({ type: String, default: '400px' }),
        __metadata("design:type", String)
    ], PromptDialog.prototype, "maxWidth", void 0);
    __decorate([
        Prop({ type: Boolean, default: true }),
        __metadata("design:type", Boolean)
    ], PromptDialog.prototype, "persistent", void 0);
    __decorate([
        Prop({ type: String, default: 'secondary' }),
        __metadata("design:type", String)
    ], PromptDialog.prototype, "cancelColor", void 0);
    __decorate([
        Prop({ type: Boolean, default: true }),
        __metadata("design:type", Boolean)
    ], PromptDialog.prototype, "cancelDark", void 0);
    __decorate([
        Prop({ type: String, default: 'error' }),
        __metadata("design:type", String)
    ], PromptDialog.prototype, "okColor", void 0);
    __decorate([
        Prop({ type: Boolean, default: true }),
        __metadata("design:type", Boolean)
    ], PromptDialog.prototype, "okDark", void 0);
    __decorate([
        Prop({ type: Boolean, default: true }),
        __metadata("design:type", Boolean)
    ], PromptDialog.prototype, "okVisible", void 0);
    __decorate([
        Emit('cancelled'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PromptDialog.prototype, "cancelled", null);
    __decorate([
        Emit('accepted'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PromptDialog.prototype, "accepted", null);
    __decorate([
        Watch('value', { immediate: false, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean, Boolean]),
        __metadata("design:returntype", void 0)
    ], PromptDialog.prototype, "onValueChanged", null);
    PromptDialog = __decorate([
        Component({})
    ], PromptDialog);
    return PromptDialog;
}(Vue));
export default PromptDialog;
